const C = {
  bg:               '#0a0e17',
  surface:          '#0f1520',
  surfaceElevated:  '#131a2b',
  border:           'rgba(255,255,255,0.06)',
  borderHover:      'rgba(255,255,255,0.12)',
  red:              '#ef4444',
  green:            '#22c55e',
  amber:            '#f59e0b',
  blue:             '#3b82f6',
  purple:           '#a78bfa',
  orange:           '#f97316',
  pink:             '#ec4899',
  textPrimary:      '#e2e8f0',
  textSecondary:    '#94a3b8',
  textMuted:        '#64748b',
};

export default C;
